import { Slider } from '../controls/Slider';
import { useActive } from './useActive';
import { useUi } from '../../state/ui';
import { useT } from '../../i18n';

export function WbPanel() {
  const t = useT();
  const { settings, update } = useActive();
  const tool = useUi((s) => s.tool);
  const picking = tool === 'wbPicker';
  return (
    <div>
      <button
        aria-pressed={picking}
        data-testid="wb-eyedropper"
        onClick={() => useUi.getState().set({ tool: picking ? 'none' : 'wbPicker' })}
        style={{ marginBottom: 6, ...(picking ? { background: 'var(--accent)', color: '#fff' } : {}) }}
      >
        {t('eyedropper')}
      </button>
      {picking && <div style={{ fontSize: 12, marginBottom: 6 }}>{t('eyedropperHint')}</div>}
      <Slider
        label="temp"
        testId="slider-temp"
        value={settings.wb.temp}
        min={-100}
        max={100}
        step={1}
        onChange={(v, f) => update((s) => void (s.wb.temp = v), f)}
      />
      <Slider
        label="tint"
        testId="slider-tint"
        value={settings.wb.tint}
        min={-100}
        max={100}
        step={1}
        onChange={(v, f) => update((s) => void (s.wb.tint = v), f)}
      />
    </div>
  );
}
